import styles from './nodeDetail.module.css'
import { cx } from './utils'

interface InfoRowProps {
  label: string
  value: string | null | undefined
  mono?: boolean
}

export function InfoRow({ label, value, mono }: InfoRowProps) {
  return (
    <div className={styles.infoRow}>
      <span className={styles.infoRowLabel}>{label}</span>
      <span className={cx(styles.infoRowValue, mono && styles.infoRowValueMono)}>
        {value ?? '—'}
      </span>
    </div>
  )
}
